module.exports = "<app-header></app-header>\n<app-footer></app-footer>"